<template>
  <v-autocomplete
    v-model="federation"
    :items="tenantList"
    item-text="descrizione"
    item-value="id_tenant"
    :label="label"
    :hint="hint"
    :rules="required ? [$validate.isNotAnEmptyArray] : []"
    :required="required"
    multiple
    clearable
    :disabled="disabled"
    :append-icon="!filter ? 'select_all' : null"
    @click:append="selectAll"
  >
    <template slot="selection" slot-scope="data" v-if="federation && federation.length">
      <v-chip label small close @input="removeTenant(data.item)">{{
        data.item.descrizione
      }}</v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { $EventBus } from '@/eventBus';
import { $decode } from '@/mixins/decode';
import _ from 'lodash';
export default {
  props: {
    value: Array,
    required: Boolean,
    disabled: Boolean,
    filter: Boolean, // usato come filtro di ricerca?
    label: String,
    hint: String,
    component: String,
  },
  data: () => ({
    tenants: null,
    federation: null,
  }),
  mixins: [$decode],
  computed: {
    tenantList() {
      // per avere il codice nella descrizione della lista delle opzioni
      if (this.tenants) {
        let list = null;
        if (this.component == 'news') {
          list = _.filter(this.tenants, (element) => {
            // se un tenant è tipo project base non appare tra quelli disponibili
            return element.type != 'base' || element.flavor != 'project';
          });
          list = _.filter(list, (element) => {
            // se un tenant è un event deve essere incluso nel caso in cui il dominio è == null
            if (element.flavor != 'event') return element;
            else {
              if (element.domain == null || element.domain.length == 0) return element;
            }
          });
        } else {
          list = this.tenants;
        }
        return list.map((t) => {
          return {
            id_tenant: t.id_tenant,
            descrizione: `${t.business_id} - ${t.i18n_name[t.default_lang]}`,
          };
        });
      } else {
        return null;
      }
    },
  },
  methods: {
    getTenants() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'get',
          url: '/tenants',
          params: { enabled: 1 },
        })
          .then((response) => {
            resolve(response.data.items);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
            $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare i tenant' });
          });
      });
    },
    removeTenant(item) {
      const index = this.federation.indexOf(item.id_tenant);
      if (index >= 0) {
        this.federation.splice(index, 1);
      }
    },
    selectedTenants() {
      // lista con codice e descrizione dei tenant selezionati (per eventuali usi nel component padre)
      if (this.tenants && this.federation) {
        return this.tenants.filter((c) => this.federation.indexOf(c.id_tenant) !== -1);
      }
    },
    selectAll() {
      this.federation = this.tenants.map((t) => t.id_tenant);
    },
  },
  watch: {
    federation(newValue) {
      this.federation = newValue;
      this.$emit('input', this.federation);
      this.$emit('federation:selection', this.selectedTenants());
    },
    value(newValue) {
      this.federation = newValue;
    },
  },
  mounted() {
    this.getTenants().then((tenants) => {
      this.tenants = this.$userHasRoles(['admin'])
        ? tenants
        : tenants.filter((t) => this.$user.tenants.includes(t.id_tenant)); // quelli che può vedere
      if (!this.filter) {
        // popola il model solo quando è usato come campo e non come filtro: ad esempio, non voglio vedere le chip già popolate nella ricerca
        this.federation = this.value;
        this.$emit('federation:selection', this.selectedTenants());
      }
    });
  },
};
</script>
